/* eslint-disable no-shadow */
const state = {
	fasion: []
}

const getters = {
	getFasion: state => state.fasion
}

const mutations = {
	setFasionMutation: (state, payload) => {
		const product = state.fasion
			.filter(fasion => fasion.product_id === payload.product_id)
		if (product.length === 0) {
			state.fasion.push(payload)
		}
	},

	clearFasionMutation: (state) => {
		state.fasion = []
	}
}

const actions = {

	setFasionData: ({
		commit
	}, payload) => {
		commit('setFasionMutation', payload)
	},

	clearFasionData: ({
		commit
	}, payload) => {
		commit('clearFasionMutation', payload)
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}
